/**
 * @name default-breackpoints.constants
 * @description Default breackpoints in responsive configuration.
 *
 * @author Manu Cutillas
 * @license MIT
 */
export const DEFAULT_BREACKPOINTS = {
    breakPoints: {
        xs: { max: 767 },
        sm: { min: 768, max: 991 },
        md: { min: 992, max: 1199 },
        lg: { min: 1200, max: 1599 },
        xl: { min: 1600 }
    },
    debounceTime: 100
}